import { render, staticRenderFns } from "./CompanyConfigCrudForm.vue?vue&type=template&id=bbae8232&"
import script from "./CompanyConfigCrudForm.vue?vue&type=script&lang=js&"
export * from "./CompanyConfigCrudForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports